import { Anchor, Breadcrumbs, Card, Grid } from '@mantine/core';
import { useParams } from 'react-router';
import Metadata from '../../components/Metadata';
import { Page } from '../../constants/pageTitles';
import ProfilesForm from './ProfilesForm';

const page = `${Page['profiles']}`;

const ProfileNewPage = () => {
  const { accountId, domainId } = useParams();

  return (
    <>
      <Metadata title={`${page} | New`} />
      <Breadcrumbs mb="md">
        <Anchor href={`#/accounts/${accountId}/domains/${domainId}/analytics`}>Home</Anchor>
        <Anchor href={`#/accounts/${accountId}/domains/${domainId}/profiles`}>{page}</Anchor>
        <span>New</span>
      </Breadcrumbs>

      <Grid>
        <Grid.Col span={12}>
          <Card withBorder>
            <ProfilesForm />
          </Card>
        </Grid.Col>
      </Grid>
    </>
  );
};

export default ProfileNewPage;
